import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import IO from 'socket.io-client';

/**
 * Realtime Events manager.
 */
var RealTimeEvents = /*#__PURE__*/function () {
  function RealTimeEvents() {
    _classCallCheck(this, RealTimeEvents);
    /**
     * Internal handlers map.
     */
    this._handlers = new Map();
  }
  return _createClass(RealTimeEvents, [{
    key: "connect",
    value:
    /**
     * Connects to the specified host and attempts to authenticate.
     */
    function connect(host, token) {
      var _this = this;
      if (this.io) {
        this.disconnect();
      }
      var url = new URL(host);
      var pathname = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
      this.io = IO(url.origin, {
        path: "".concat(pathname, "/socket.io"),
        transports: ['websocket']
      });
      this.io.on('event', function (evt) {
        _this.trigger('event', evt);
      });
      this.io.once('connect', function () {
        _this.io.emit('authenticate', {
          token: token
        }, function (result) {
          if (result.success) {
            _this.trigger('authenticate:success');
            return;
          }
          console.error('Could not authenticate with event server: ', result);
          _this.trigger('authenticate:error', result);
        });
      });
      return this;
    }

    /**
     * Disconnects.
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.io.close();
      this.io.off();
      delete this.io;
    }

    /**
     * Subscribes to a real-time event with the specified type.
     * Returns an unsubscribe function.
     */
  }, {
    key: "subscribe",
    value: function subscribe(event, handler) {
      return this.on('event', function (evt) {
        if (evt.type === event) {
          handler(evt.data);
        }
      });
    }

    /**
     * Subscribes to an event on the class. To subscribe to specific
     * real-time events, use `subscribe`.
     */
  }, {
    key: "on",
    value: function on(event, handler) {
      var _this2 = this;
      var handlers = this._handlers.get(event);
      var _shouldSet = !handlers;
      handlers = handlers || [];
      if (_shouldSet) {
        this._handlers.set(event, handlers);
      }
      handlers.push(handler);
      var removeListener = function removeListener() {
        _this2._removeHandler(event, handler);
      };
      return removeListener;
    }

    /**
     * Removes a specific handler, or an entire class of handlers.
     */
  }, {
    key: "off",
    value: function off(event, handler) {
      if (event && handler) {
        this._removeHandler(event, handler);
        return;
      }
      if (event && !handler) {
        this._handlers.set(event, []);
        return;
      }
      this._handlers = new Map();
    }

    /**
     * Triggers the specified event.
     */
  }, {
    key: "trigger",
    value: function trigger(event, data) {
      var handlers = this._handlers.get(event);
      if (handlers) {
        handlers.forEach(function (h) {
          return h(data);
        });
      }
      return this;
    }

    /**
     * Removes a single handler.
     */
  }, {
    key: "_removeHandler",
    value: function _removeHandler(event, handler) {
      var handlers = this._handlers.get(event);
      if (handlers) {
        var idx = handlers.indexOf(handler);
        if (idx > -1) {
          handlers.splice(idx, 1);
        }
      }
    }
  }]);
}();
export { RealTimeEvents as default };
//# sourceMappingURL=RealTimeEvents.js.map
